// extracted by mini-css-extract-plugin
export default {"activeAction":"nonLayoutNavigationItem_activeAction__6okDG","hoveredAction":"nonLayoutNavigationItem_hoveredAction__mTb8y"};